import { render, staticRenderFns } from "./AddWeeklyReport.vue?vue&type=template&id=6847ea88"
import script from "./AddWeeklyReport.vue?vue&type=script&lang=ts"
export * from "./AddWeeklyReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports